import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getFirestore, setLogLevel as setFirestoreLogLevel, type Firestore } from 'firebase/firestore';
import { getAuth, type Auth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Validate Firebase configuration by checking the actual config object.
// Note: databaseURL is NOT included here — RTDB is lazily initialized via rtdb.ts
// only when a valid VITE_FIREBASE_DATABASE_URL is configured.
const missingConfigKeys = Object.entries(firebaseConfig)
  .filter(([, value]) => !value || value === 'undefined')
  .map(([key]) => key);

if (missingConfigKeys.length > 0) {
  console.error('❌ Missing Firebase configuration values:', missingConfigKeys);
  console.error('Firebase Config State:', firebaseConfig);
  console.error('Environment:', {
    mode: import.meta.env.MODE,
    dev: import.meta.env.DEV,
    prod: import.meta.env.PROD
  });
  throw new Error(`Firebase configuration incomplete. Missing: ${missingConfigKeys.join(', ')}`);
}

let app: FirebaseApp;
let db: Firestore;
let auth: Auth;

try {
  app = initializeApp(firebaseConfig);
  setFirestoreLogLevel(import.meta.env.VITE_ENABLE_DEBUG_LOGS === 'true' ? 'debug' : 'error');
  db = getFirestore(app);
  auth = getAuth(app);
} catch (error) {
  console.error('❌ Failed to initialize Firebase:', error);
  throw error;
}

export { db, auth };
export default app;
